import "core-js/modules/es.array.push.js";
import "core-js/modules/web.url-search-params.delete.js";
import "core-js/modules/web.url-search-params.has.js";
import "core-js/modules/web.url-search-params.size.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Pagination from '@/components/Pagination/index.vue';
import { downloadDepoTransitExcel, getDepoDispatchProducts } from '@/api/orders-products-dispatches';
import moment from 'moment';
import { makeAdjustments, viewDispatchInvoice } from '@/api/ledgers';
import { searchDealers } from '@/api/dealers';
import { AdminModule } from '@/store/modules/admin';
import { UNIT_MANAGER, SUPER_ADMIN } from '@/constants/roles.constants';
let default_1 = class extends Vue {
  constructor() {
    super(...arguments);
    this.list = [];
    this.tableKey = 0;
    this.listLoading = true;
    this.dealerListLoading = false;
    this.downloadLoading = false;
    this.adjustmentsLoading = false; // Add this line
    this.dealerList = [];
    this.dateRange = '';
    this.total = 0;
    this.loggedInAdmin = null;
    this.listQuery = {
      dealerId: undefined,
      adminId: undefined,
      stockBranchId: undefined,
      adjustmentType: undefined,
      startDate: undefined,
      endDate: undefined,
      page: 1,
      limit: 10
    };
    this.isTushar = false;
    this.isSuperAdmin = false;
    this.adjustmentTypeOptions = [{
      label: 'Credit Note-Item Wise',
      value: 'Credit Note-Item Wise'
    }, {
      label: 'Debit Note-Item Wise',
      value: 'Debit Note-Item Wise'
    }, {
      label: 'Replacement',
      value: 'Replacement'
    }];
    this.shortcuts = [{
      key: 'thisWeek',
      label: 'This week',
      value: 'isoWeek'
    }, {
      key: 'lastWeek',
      label: 'Last week',
      value: '-isoWeek'
    }, {
      key: 'last7Days',
      label: 'Last 7 days',
      value: 7
    }, {
      key: 'last30Days',
      label: 'Last 30 days',
      value: 30
    }, {
      key: 'thisMonth',
      label: 'This month',
      value: 'month'
    }, {
      key: 'lastMonth',
      label: 'Last month',
      value: '-month'
    }, {
      key: 'thisYear',
      label: 'This FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3; // April (0-indexed as 3 in moment.js)
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // If before April, move to the previous financial year
          startYear--;
        }
        const thisFinancialYearStart = moment([startYear, startMonth, startDay]);
        const thisFinancialYearEnd = moment([startYear + 1, startMonth, startDay]).subtract(1, 'days');
        return {
          start: thisFinancialYearStart,
          end: thisFinancialYearEnd
        };
      }
    }, {
      key: 'lastYear',
      label: 'Last FY',
      value: () => {
        const currentDate = moment();
        let startYear = currentDate.year();
        // Financial year starts in April
        const startMonth = 3;
        const startDay = 1;
        if (currentDate.month() <= 2) {
          // Before April, use the previous financial year
          startYear--;
        }
        const lastFinancialYearStart = moment([startYear - 1, startMonth, startDay]);
        const lastFinancialYearEnd = moment([startYear, startMonth, startDay]).subtract(1, 'days');
        return {
          start: lastFinancialYearStart,
          end: lastFinancialYearEnd
        };
      }
    }];
  }
  activated() {
    this.loggedInAdmin = AdminModule;
    if (AdminModule.branchIds.length > 0) {
      this.listQuery.stockBranchId = AdminModule.branchIds;
    }
    if (this.loggedInAdmin.adminsRoleIds.includes(UNIT_MANAGER)) {
      this.listQuery.adminId = this.loggedInAdmin.id;
    }
    if (this.loggedInAdmin.id === 44) {
      this.isTushar = true;
    }
    if (this.loggedInAdmin.adminsRoleIds.includes(SUPER_ADMIN)) {
      this.isSuperAdmin = true;
    }
    this.getList();
  }
  async getList() {
    try {
      this.listLoading = true;
      const data = await getDepoDispatchProducts(this.listQuery);
      this.list = this.sortByInvoiceNumber(data.data);
      this.total = data.total;
      this.listLoading = false;
    } catch (error) {
      this.listLoading = false;
    }
  }
  sortByInvoiceNumber(list) {
    const getInvoiceNumber = row => {
      var _row$ordersDispatch;
      const invoiceNumber = (row === null || row === void 0 || (_row$ordersDispatch = row.ordersDispatch) === null || _row$ordersDispatch === void 0 ? void 0 : _row$ordersDispatch.invoiceNumber) || '';
      const lastSegment = invoiceNumber.split('/').pop();
      const numeric = parseInt(lastSegment, 10);
      return isNaN(numeric) ? 0 : numeric;
    };
    return [...list].sort((a, b) => getInvoiceNumber(a) - getInvoiceNumber(b));
  }
  formatDate(timestamp) {
    return moment(timestamp).format('DD-MM-YYYY');
  }
  showComments(row) {
    let comments = null;
    if (row.isWrongProduct) {
      const productName = (row === null || row === void 0 ? void 0 : row.actualProductName) || '';
      const variationName = (row === null || row === void 0 ? void 0 : row.actualVariationName) || '';
      if (variationName) {
        comments = `${productName}-${variationName}`;
      } else {
        comments = `${productName}`;
      }
    } else {
      comments = row.comments;
    }
    comments = row.comments;
    return comments;
  }
  objectSpanMethod({
    row,
    column,
    rowIndex,
    columnIndex
  }) {
    const shouldGroupForActions = (row1, row2) => {
      return row1.ordersDispatchId === row2.ordersDispatchId && row1.ordersDispatch.invoiceNumber === row2.ordersDispatch.invoiceNumber && row1.sourceAdjustmentType === row2.sourceAdjustmentType && row1.destinationAdjustmentType === row2.destinationAdjustmentType;
    };
    const shouldGroupForInvoice = (row1, row2) => {
      return row1.ordersDispatchId === row2.ordersDispatchId && row1.ordersDispatch.invoiceNumber === row2.ordersDispatch.invoiceNumber;
    };
    // Apply spanning to Invoice Number and Dealer Name columns
    if (columnIndex === 0 || columnIndex === 1) {
      if (rowIndex === 0) {
        let rowspan = 1;
        for (let i = 1; i < this.list.length; i++) {
          if (shouldGroupForInvoice(this.list[0], this.list[i])) {
            rowspan++;
          } else {
            break;
          }
        }
        return {
          rowspan: rowspan,
          colspan: 1
        };
      } else {
        const prevRow = this.list[rowIndex - 1];
        if (shouldGroupForInvoice(row, prevRow)) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.list.length; i++) {
            if (shouldGroupForInvoice(row, this.list[i])) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan: rowspan,
            colspan: 1
          };
        }
      }
    }
    // Apply spanning to Actions column (adjust columnIndex as needed)
    if (columnIndex === 10) {
      if (rowIndex === 0) {
        let rowspan = 1;
        for (let i = 1; i < this.list.length; i++) {
          if (shouldGroupForActions(this.list[0], this.list[i])) {
            rowspan++;
          } else {
            break;
          }
        }
        return {
          rowspan: rowspan,
          colspan: 1
        };
      } else {
        const prevRow = this.list[rowIndex - 1];
        if (shouldGroupForActions(row, prevRow)) {
          return {
            rowspan: 0,
            colspan: 0
          };
        } else {
          let rowspan = 1;
          for (let i = rowIndex + 1; i < this.list.length; i++) {
            if (shouldGroupForActions(row, this.list[i])) {
              rowspan++;
            } else {
              break;
            }
          }
          return {
            rowspan: rowspan,
            colspan: 1
          };
        }
      }
    }
    return {
      rowspan: 1,
      colspan: 1
    };
  }
  async viewDispatchInvoice(id) {
    try {
      // get invoice url
      this.listLoading = true;
      const url = await viewDispatchInvoice(id);
      if (url) {
        window.open(url, '_blank');
      } else {
        this.$message({
          message: 'Failed to generate invoice',
          type: 'error'
        });
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.listLoading = false;
    }
  }
  async getDealerList(query = null) {
    try {
      const isNumeric = /^[0-9]+$/.test(query);
      // search only if length is greater than 1 if query is id else 2
      if (!query || (isNumeric ? query.length < 1 : query.length < 2)) {
        this.dealerList = [];
        return;
      }
      const searchParams = {
        keyword: query,
        applyBranchIdFilter: true,
        fromDealer: true,
        searchBy: isNumeric ? 'dealerId' : 'name'
      };
      if (this.listQuery.branchId !== undefined) {
        searchParams.branchId = this.listQuery.branchId;
      }
      if (this.listQuery.agentId !== undefined) {
        searchParams.agentId = this.listQuery.agentId;
      }
      this.dealerList = await searchDealers(searchParams);
    } catch (error) {} // eslint-disable-line  no-empty
  }
  async handleFilter() {
    if (this.dateRange) {
      this.listQuery.startDate = this.dateRange.start;
      this.listQuery.endDate = this.dateRange.end;
    } else {
      this.listQuery.startDate = undefined;
      this.listQuery.endDate = undefined;
    }
    await this.getList();
  }
  async handleExcelDownload() {
    try {
      this.downloadLoading = true;
      const blob = await downloadDepoTransitExcel(this.listQuery);
      // Create a blob URL for the Excel file
      const url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', 'depo-transit.xlsx');
      document.body.appendChild(link);
      // Simulate click to trigger download
      link.click();
      // Clean up
      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      this.downloadLoading = false;
      console.log(error);
      this.$message.error('Error downloading Excel');
    }
  }
  getGroupedRows(row, rowIndex) {
    const groupedRows = [row];
    const shouldGroupForActions = (row1, row2) => {
      return row1.ordersDispatchId === row2.ordersDispatchId && row1.ordersDispatch.invoiceNumber === row2.ordersDispatch.invoiceNumber && row1.sourceAdjustmentType === row2.sourceAdjustmentType && row1.destinationAdjustmentType === row2.destinationAdjustmentType;
    };
    // Check backward for rows in the same group
    for (let i = rowIndex - 1; i >= 0; i--) {
      if (shouldGroupForActions(row, this.list[i])) {
        groupedRows.unshift(this.list[i]);
      } else {
        break;
      }
    }
    // Check forward for rows in the same group
    for (let i = rowIndex + 1; i < this.list.length; i++) {
      if (shouldGroupForActions(row, this.list[i])) {
        groupedRows.push(this.list[i]);
      } else {
        break;
      }
    }
    return groupedRows;
  }
  // Updated handler function
  async handleAdjustments(row, rowIndex) {
    const groupedRows = this.getGroupedRows(row, rowIndex);
    try {
      this.adjustmentsLoading = true; // Show loading
      await makeAdjustments(groupedRows);
      this.$message.success('Adjustments completed successfully ✅');
    } catch (error) {
      this.$message.error('Error making adjustments ❌');
    } finally {
      this.adjustmentsLoading = false; // Hide loading
      this.getList();
    }
  }
};
default_1 = __decorate([Component({
  name: 'DepoTransitList',
  components: {
    Pagination
  }
})], default_1);
export default default_1;